import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Form, Checkbox, Header, Icon, Segment } from "semantic-ui-react";

class RecallsConfiguration extends Component {
  handleCheckboxChange = (e, { name, checked }) => {
    const { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked });
  };

  render() {
    const { location, t } = this.props;

    return (
      <Segment>
        <Header as="h5">
          <Icon name="settings" />
          <Header.Content>{t("distrimate_recalls_configuration").message || "Distrimate Recalls Configuration"}</Header.Content>
        </Header>
        <Form>
          <Form.Field>
            <Checkbox
              checked={location.is_recalls_service_enabled}
              name="is_recalls_service_enabled"
              label={t("import_recall").message || "Import recalls"}
              onChange={this.handleCheckboxChange}
            />
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

export default withTranslation()(RecallsConfiguration);
